import appClient from './appClient';

export const addToCart = async (productId) => {
    try {
        // Логируем запрос
        console.log(`Adding product ${productId} to cart`);

        // Выполняем запрос
        await appClient.post(`/cart/add`, {productId});

        // Логируем успешный результат
        console.info(`Product ${productId} added to cart`);
    } catch (error) {
        // Логируем ошибку
        console.error(`Error adding product ${productId} to cart:`, error);

        // Выбрасываем ошибку для обработки в вызывающем коде
        throw new Error(`Failed to add product ${productId} to cart`);
    }
};

export const removeFromCart = async (productId) => {
    try {
        // Логируем запрос
        console.log(`Removing product ${productId} from cart`);

        // Выполняем запрос
        await appClient.delete(`/cart/remove`, {params:{productId}});

        // Логируем успешный результат
        console.info(`Product ${productId} removed from cart`);
    } catch (error) {
        // Логируем ошибку
        console.error(`Error removing product ${productId} from cart:`, error);

        // Выбрасываем ошибку для обработки в вызывающем коде
        throw new Error(`Failed to remove product ${productId} from cart`);
    }
};

export const getCart = async () => {
    try {
        // Логируем запрос
        console.log(`Fetching cart...`);

        // Выполняем запрос
        const response = await appClient.get(`/cart`);

        // Логируем ответ
        console.log('API getCart response:', response.data);
        return response.data
    } catch (error) {
        // Логируем ошибку
        console.error(`Error fetching cart:`, error);

        // Выбрасываем ошибку для обработки в вызывающем коде
        throw new Error(`Failed to fetch cart`);
    }
};

export const clearCart = async () => {
    try {
        // Логируем запрос
        console.log(`Clearing cart...`);

        // Выполняем запрос
        await appClient.delete(`/cart/clear`);

        // Логируем успешный результат
        console.info(`Cart cleared`);
    } catch (error) {
        // Логируем ошибку
        console.error(`Error clearing cart:`, error);

        // Выбрасываем ошибку для обработки в вызывающем коде
        throw new Error(`Failed to clear cart`);
    }
};